import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import ScrollBar from "react-perfect-scrollbar";
import * as cls from "./modalZetLessons.module.scss";
import {
  showZetLessonDetailAction,
  zetLessonDetailDataAction,
} from "../../redux/actions/actions";
import Warn from "../../resources/icons/Warn";
import {
  WidgetFrame,
  ErrataWidget,
  Button,
  Icon,
} from "../../../personal-studio-components/studio";
import { ErrataViewInfo } from "../../../personal-studio-components/service/ErrataViewInfo";
// import "react-perfect-scrollbar/dist/css/styles.css";
// import "./perfect-scrollbar.scss";
import { useNavigate } from "react-router-dom";
import TableItem from "./TableItem";
const product_states = {
  Начать: "normal",
  Продолжить: "continue_session",
  Пройдено: "completed",
  "Требуется оплата": "not_paid",
  Перезапись: "self_record_rewrite",
  "Дата не наступила": "self_record_date_assigned",
  Запланировать: "self_record_needed",
  Недоступно: "unavailable",
};

function ModalZetLessons({ children }) {
  const dispatch = useDispatch();
  const [accessabilityMode, setAccessabilityMode] = useState(
    localStorage.getItem("personal-studio-components.accessibility.font") ||
      "0",
  );
  const { zetLessonData, open } = useSelector(
    (state) => state.zetLessonReducer,
  );
  const navigate = useNavigate();
  useEffect(() => {
    // document.body.style.overflow = open ? "hidden" : "auto";
    setAccessabilityMode(
      localStorage.getItem("personal-studio-components.accessibility.font"),
    );
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const handleClose = () => {
    dispatch(showZetLessonDetailAction(false));
    dispatch(zetLessonDetailDataAction(null));
  };

  useEffect(() => {
    if (zetLessonData && zetLessonData.lessons.error_type === "auth") {
      const err = zetLessonData.lessons;
      const errorEvent = new ErrorEvent("error", { error: err });
      window.dispatchEvent(errorEvent);
    }
  }, [zetLessonData]);
  if (!open) return children;
  window.scrollTo(0, 0);
  // useEffect(() => {
  //   if (
  //     zetLessonData &&
  //     zetLessonData.lessons &&
  //     !zetLessonData.lessons.errors
  //   ) {
  //   }
  // }, [zetLessonData]);
  return (
    <div
      className={
        zetLessonData === null ? cls.modalOverlayLoad : cls.modalOverlay
      }
    >
      {zetLessonData === null ? (
        <div className={cls.modalContainerLoad}>
          <WidgetFrame icon="loading" title="Загрузка" />
          {/*
          <div className={cls.dialogActions}>
            <Button type="primary" onClick={handleClose}>
              Закрыть
            </Button>
          </div>
          */}
        </div>
      ) : zetLessonData?.lessons.errors ? (
        <div className={cls.modalContainer}>
          {zetLessonData?.lessons.error_type === "info" ? (
            <>
              <div className={cls.modalHeader}>
                <h2 className={cls.modalTitle}>
                  {zetLessonData.discip_short_name}
                </h2>

                <button className={cls.closeButton} onClick={handleClose}>
                  🡰{}
                </button>
              </div>
              <ErrataViewInfo errata={zetLessonData.lessons} />
            </>
          ) : zetLessonData?.lessons.error_type === "redirect_info" ? (
            <>
              <div className={cls.modalHeader}>
                <h2 className={cls.modalTitle}>
                  {zetLessonData.discip_short_name}
                </h2>
                <button className={cls.closeButton} onClick={handleClose}>
                  🡰{}
                </button>
              </div>
              <ErrataViewInfo errata={zetLessonData.lessons} />
            </>
          ) : (
            zetLessonData?.lessons.error_type !== "auth" && (
              <>
                <div className={cls.modalHeader}>
                  <h2 className={cls.modalTitle}>
                    {zetLessonData.discip_short_name}
                  </h2>
                  <button className={cls.closeButton} onClick={handleClose}>
                    🡰{}
                  </button>
                </div>
                <ErrataWidget errata={zetLessonData.lessons} />
              </>
            )
          )}
          {/*
          <div className={cls.dialogActions}>
            <Button type="primary" onClick={handleClose}>
              Закрыть
            </Button>
          </div>
          */}
        </div>
      ) : (
        <div
          className={cls.modalContainer}
          style={
            {
              // maxHeight: `${
              //   accessabilityMode === "0"
              //     ? "calc(90vh)"
              //     : accessabilityMode === "1"
              //     ? "calc(" + 90 * 0.8 + "vh)"
              //     : "calc(" + 90 * 0.66 + "vh)"
              // }`,
            }
          }
        >
          <div className={cls.modalHeader}>
            <h2 className={cls.modalTitle}>
              {zetLessonData.discip_short_name}
              {/* ЗЕТ № {zetLessonData.zet_name} */}
            </h2>
            <button className={cls.closeButton} onClick={handleClose}>
              🡰{}
            </button>
          </div>
          <div className={cls.scrollContainer}>
            <div className={cls.tableContainer}>
              {/* <div className={cls.tableHeaderContainer}>
                <div className={cls.tableRowHeader}>
                  <div className={cls.mustEvaluate}></div>
                  <div className={cls.tableHeader}>Вид занятия</div>
                  <div className={cls.tableHeaderTpName}>Тема занятия</div>
                  <div className={cls.tableHeader}>Обучение</div>
                </div>
              </div> */}
              <div className={cls.table}>
                {zetLessonData &&
                  zetLessonData.lessons.with_topic &&
                  zetLessonData.lessons.with_topic.map((el, idx) => {
                    const depth = el.topic.length;
                    return (
                      <div key={idx}>
                        <div className={cls.topics}>
                          {el.topic.map((item, tIndex, topics) => (
                            <div
                              key={tIndex}
                              style={{
                                "--marginLeft": `${(tIndex + 1) * 20}px`,
                              }}
                              className={cls.topicItem}
                            >
                              {tIndex !== 0 && (
                                <div
                                  className={cls.arrowTree}
                                  style={{
                                    height: "0.6rem",
                                    width: "0.5rem",
                                  }}
                                />
                              )}

                              <label style={{ fontWeight: "700" }}>
                                {item}
                              </label>
                              {tIndex < topics.length - 1 && (
                                <div className={cls.iconContainer}>
                                  <Icon name="arrow_right" />
                                </div>
                              )}
                            </div>
                          ))}
                        </div>

                        <div
                          className={cls.tableRowWrap}
                          style={{ "--marginLeft": `${depth * 20}px` }}
                        >
                          <div className={cls.tableHeaderContainer}>
                            <div className={cls.tableRowHeader}>
                              <div className={cls.mustEvaluate}></div>
                              <div className={cls.tableHeader}>Вид занятия</div>
                              <div className={cls.tableHeaderTpName}>
                                Тема занятия
                              </div>
                              <div className={cls.tableHeader}>Обучение</div>
                            </div>
                          </div>

                          {el.lesson.map((lesson, lIndex) => (
                            <TableItem
                              withTopic
                              key={lIndex}
                              el={lesson}
                              handleClose={handleClose}
                            />
                          ))}
                        </div>
                      </div>
                    );
                  })}

                {/*<div style={{ minHeight: "100px" }}></div>*/}
              </div>
              <div style={{ marginTop: "30px" }}></div>
              <div className={cls.tableHeaderContainer}>
                <div className={cls.tableRowHeader}>
                  <div className={cls.mustEvaluate}></div>
                  <div className={cls.tableHeader}>Вид занятия</div>
                  <div className={cls.tableHeaderTpName}>Тема занятия</div>
                  <div className={cls.tableHeader}>Обучение</div>
                </div>
              </div>
              <div className={cls.table}>
                {zetLessonData &&
                  zetLessonData.lessons.without_topic &&
                  zetLessonData.lessons.without_topic.map((el, idx) => (
                    <TableItem
                      withTopic={false}
                      key={idx}
                      el={el}
                      handleClose={handleClose}
                    />
                  ))}
                {/*<div style={{ minHeight: "100px" }}></div>*/}
              </div>
            </div>
          </div>
          {/*
          <div className={cls.dialogActions}>
            <Button type="primary" onClick={handleClose}>
              Закрыть
            </Button>
          </div>
          */}
        </div>
      )}
    </div>
  );
}
// const scrollbarOptions = {
//   suppressScrollX: true,
//   wheelPropagation: false,
//   // Всегда показывать вертикальный скроллбар
//   suppressScrollY: false,
//   useBothWheelAxes: true,
//   minScrollbarLength: 1,
// }
export default ModalZetLessons;
